import React, { useState,useEffect } from 'react';
import {
    TextField,
    FormHelperText,
    Button,
    Typography,
} from '@material-ui/core';

// 你需要保证有可用的 dataProvider，路径依你的项目情况而定
import dataProvider from '../dataProvider';

// 添加 getUserURL 导入
import { getUserURL } from '../api';
import { COUNTRY_LIST } from '../constants/countries';
import SearchableSelect from '../common/SearchableSelect';
import AddressAutocomplete from '../common/AddressAutocomplete';

// 验证函数
const validateFirstName = (name) => {
    if (!name) {
        return 'First Name is required.';
    }
    return '';
};

const validateLastName = (name) => {
    if (!name) {
        return 'Last Name is required.';
    }
    return '';
};

const validateDOB = (dob) => {
    if (!dob) {
        return 'Date of Birth is required';
    }
    return '';
};

const validatePhone = (phone) => {
    if (!phone) {
        return 'Phone Number is required';
    }
    return '';
};

const validateSSN = (ssn) => {
    if (!ssn) {
        return 'SSN or ITIN is required';
    }
    // 基本的 SSN 格式验证 (XXX-XX-XXXX)
    /*const ssnRegex = /^\d{3}-?\d{2}-?\d{4}$/;
    if (!ssnRegex.test(ssn.replace(/-/g, ''))) {
        return 'Please enter a valid SSN or ITIN';
    }*/
    return '';
};

const validateAddress = (address) => {
    if (!address) {
        return 'Street Address is required.';
    }
    return '';
};

const validateCity = (city) => {
    if (!city) {
        return 'City is required.';
    }
    return '';
};

const validateState = (state) => {
    if (!state) {
        return 'State is required.';
    }
    return '';
};

const validatePostalCode = (postalCode) => {
    if (!postalCode) {
        return 'Postal Code is required.';
    }
    return '';
};

const ImagePreview = ({ imageData }) => {
    if (!imageData || !imageData.url) return null;
    
    return (
        <img 
            src={imageData.url} 
            alt="ID document" 
            style={{
                maxWidth: '200px',
                maxHeight: '150px',
                marginTop: '8px',
                borderRadius: '4px'
            }}
        />
    );
};

// 修改后的UserUpdateForm组件
const UserUpdateForm = ({ handleDialogChange, isMobile }) => {
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [middleName, setMiddleName] = useState('');
    const [dob, setDob] = useState('');
    const [phone, setPhone] = useState('');
    const [ssn, setSSN] = useState('');
    
    // 地址相关状态
    const [address1, setAddress1] = useState('');
    const [address2, setAddress2] = useState('');
    const [city, setCity] = useState('');
    const [stateVal, setStateVal] = useState('');
    const [stateId, setStateId] = useState('');
    const [postalCode, setPostalCode] = useState('');
    
    // 添加 states 和 cities 数据状态
    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);
    const [loadingStates, setLoadingStates] = useState(false);
    const [loadingCities, setLoadingCities] = useState(false);
    
    const [errors, setErrors] = useState({
        dob: '',
        phone: '',
        firstName: '',
        lastName: '',
        ssn: '',
        address1: '',
        city: '',
        state: '',
        postalCode: '',
    });

    // 获取 states 数据
    useEffect(() => {
        const fetchStates = async () => {
            setLoadingStates(true);
            try {
                const response = await dataProvider('GET_LIST', 'states', {
                    pagination: { page: 1, perPage: 1000 },
                    sort: { field: 'name', order: 'ASC' },
                    filter: {}
                });
                setStates(response.data);
            } catch (error) {
                console.error('Failed to fetch states:', error);
            } finally {
                setLoadingStates(false);
            }
        };
        fetchStates();
    }, []);

    // 当 state 改变时获取对应的 cities
    useEffect(() => {
        const fetchCities = async () => {
            if (!stateId) {
                setCities([]);
                return;
            }
            setLoadingCities(true);
            try {
                const response = await dataProvider('GET_LIST', `cities/state/${stateId}`, {
                    pagination: { page: 1, perPage: 1000 },
                    sort: { field: 'name', order: 'ASC' },
                    filter: {}
                });
                setCities(response.data);
            } catch (error) {
                console.error('Failed to fetch cities:', error);
                setCities([]);
            } finally {
                setLoadingCities(false);
            }
        };
        fetchCities();
    }, [stateId]);

    const handleFirstNameChange = (e) => {
        const name = e.target.value;
        setFirstName(name);
        const error = validateFirstName(name);
        setErrors((prevErrors) => ({ ...prevErrors, firstName: error }));
    };

    const handleLastNameChange = (e) => {
        const name = e.target.value;
        setLastName(name);
        const error = validateLastName(name);
        setErrors((prevErrors) => ({ ...prevErrors, lastName: error }));
    };

    const handleAddress1Change = (e) => {
        const address = e.target.value;
        setAddress1(address);
        const error = validateAddress(address);
        setErrors((prevErrors) => ({ ...prevErrors, address1: error }));
    };

    const handleCityChange = (e) => {
        const cityName = e.target.value;
        setCity(cityName);
        const error = validateCity(cityName);
        setErrors((prevErrors) => ({ ...prevErrors, city: error }));
    };

    const handleStateChange = (e) => {
        const stateName = e.target.value;
        
        // 根据选中的 state name 找到对应的 state 对象
        const selectedState = states.find(state => state.name === stateName);
        const stateId = selectedState ? selectedState.id : '';
        
        setStateVal(stateName);
        setStateId(stateId);
        setCity(''); // 清空 city 选择
        const error = validateState(stateName);
        setErrors((prevErrors) => ({ ...prevErrors, state: error }));
    };

    const handlePostalCodeChange = (e) => {
        const postal = e.target.value;
        setPostalCode(postal);
        const error = validatePostalCode(postal);
        setErrors((prevErrors) => ({ ...prevErrors, postalCode: error }));
    };

    /*const handleImageUpload = async (file, type) => {
        const formData = new FormData();
        formData.append('image', file);

        try {
            const baseUrl = getUserURL();
            const response = await fetch(`${baseUrl}/v1/files/image`, {
                method: 'POST',
                body: formData,
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('BITFA:DASHBOARD:AUTH:TOKEN')}`,
                }
            });
            
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            
            const data = await response.json();
            
            // 从完整URL中提取文件路径
            const filePath = data.filePath;
            
            if (type === 'front') {
                setIdFront({
                    url: data.fileUrl,    // 用于显示预览
                    path: filePath        // 用于提交
                });
                // 清除ID前面的错误信息
                setErrors(prevErrors => ({ ...prevErrors, photoIdFront: '' }));
            } else {
                setIdBack({
                    url: data.fileUrl,    // 用于显示预览
                    path: filePath        // 用于提交
                });
                // 清除ID背面的错误信息
                setErrors(prevErrors => ({ ...prevErrors, photoIdBack: '' }));
            }
        } catch (error) {
            console.error('Failed to upload image:', error);
            alert('Failed to upload image');
        }
    };*/

    const handleSubmit = async () => {
        const dobError = validateDOB(dob);
        const firstNameError = validateFirstName(firstName);
        const lastNameError = validateLastName(lastName);
        //const ssnError = validateSSN(ssn);
        const address1Error = validateAddress(address1);
        const cityError = validateCity(city);
        const stateError = validateState(stateVal);
        const postalCodeError = validatePostalCode(postalCode);
        
        setErrors({
            dob: dobError,
            firstName: firstNameError,
            lastName: lastNameError,
            //ssn: ssnError,
            address1: address1Error,
            city: cityError,
            state: stateError,
            postalCode: postalCodeError,
        });

        if (
            dobError ||
            firstNameError ||
            lastNameError ||
            //ssnError ||
            address1Error ||
            cityError ||
            stateError ||
            postalCodeError
        ) {
            return;
        }

        const data = {
            firstName,
            lastName,
            middleName,
            dateOfBirth: dob,
            ssn:"",
            address: {
                address1,
                address2,
                city,
                state: stateVal,
                postalCode,
            },
        };
        
        try {
            dataProvider('UPDATE', 'user/self', { data }).then(({ response }) => {
                localStorage.setItem('BITFA:DASHBOARD:REGISTER:STEP', "0");
                if(handleDialogChange){
                    handleDialogChange();
                }
            }).catch((error) => {
                console.log("error2", error);
                alert('Failed to update user info.');
            });
        } catch (error) {
            console.log("error1", error);
            alert('Failed to update user info.');
        }
    };


    return (
        <div>
            <Typography variant="headline" style={{ marginBottom: 16 }}>
                Please fill in your personal information
            </Typography>
            

            <TextField
                label="First Name"
                value={firstName}
                onChange={handleFirstNameChange}
                fullWidth
                style={{ marginBottom: 16 }}
                error={!!errors.firstName}
                helperText={errors.firstName}
            />

            <TextField
                label="Middle Name (If any)"
                value={middleName}
                onChange={(e) => setMiddleName(e.target.value)}
                fullWidth
                style={{ marginBottom: 16 }}
            />
            
            <TextField
                label="Last Name"
                value={lastName}
                onChange={handleLastNameChange}
                fullWidth
                style={{ marginBottom: 16 }}
                error={!!errors.lastName}
                helperText={errors.lastName}
            />
            
            <TextField
                label="Date of Birth"
                type="date"
                value={dob}
                onChange={(e) => {
                    setDob(e.target.value);
                    setErrors({...errors, dob: validateDOB(e.target.value)});
                }}
                fullWidth
                style={{ marginBottom: 16 }}
                InputLabelProps={{
                    shrink: true,
                }}
                error={!!errors.dob}
                helperText={errors.dob}
            />
            {/*
            <TextField
                label="Social Security Number (SSN or ITIN)"
                value={ssn}
                onChange={(e) => {
                    setSSN(e.target.value);
                    setErrors({...errors, ssn: validateSSN(e.target.value)});
                }}
                fullWidth
                style={{ marginBottom: 16 }}
                error={!!errors.ssn}
                helperText={errors.ssn}
            />
            */}

            <Typography variant="headline" style={{ marginTop: 28 }}>
                Home Mailing Address
            </Typography>
            
            <div style={{ marginTop: 16 }}>
                <TextField
                    label="Unit Number"
                    value={address2}
                    onChange={(e) => setAddress2(e.target.value)}
                    fullWidth
                    style={{ marginTop: 16}}
                />
                <AddressAutocomplete
                    value={address1}
                    onChange={handleAddress1Change}
                    onPlaceSelected={(addressData) => {
                        setAddress1(addressData.address1);
                        setPostalCode(addressData.postalCode);
                        
                        // 只有当 state 在下拉选项中存在时才填充
                        const selectedState = states.find(state => state.name === addressData.state);
                        if (selectedState) {
                            setStateVal(addressData.state);
                            setStateId(selectedState.id);
                            setCity(addressData.city);
                            setErrors(prevErrors => ({ ...prevErrors, state: '',city: '' }));
                        }
                        
                        // 清除地址和邮编错误
                        setErrors(prevErrors => ({
                            ...prevErrors,
                            address1: '',
                            postalCode: ''
                        }));
                    }}
                    label="Street Address"
                    error={!!errors.address1}
                    helperText={errors.address1}
                />
            </div>

            {/* State Dropdown */}
            <div style={{ marginTop: 16 }}>
                <SearchableSelect
                    value={stateVal}
                    onChange={handleStateChange}
                    options={states}
                    label="State"
                    disabled={loadingStates}
                    error={!!errors.state}
                    helperText={errors.state}
                    getOptionLabel={(option) => option.name}
                    getOptionValue={(option) => option.name}
                    placeholder="Search state..."
                    allowCustom={false}
                />
            </div>

            {/* City Dropdown */}
            <div style={{ marginTop: 16 }}>
                <SearchableSelect
                    value={city}
                    onChange={handleCityChange}
                    options={cities}
                    label="City"
                    disabled={!stateId || loadingCities}
                    error={!!errors.city}
                    helperText={errors.city}
                    getOptionLabel={(option) => option.name}
                    getOptionValue={(option) => option.name}
                    placeholder="Search city..."
                />
            </div>

            <TextField
                label="Postal Code"
                value={postalCode}
                onChange={handlePostalCodeChange}
                fullWidth
                style={{ marginTop: 16 }}
                error={!!errors.postalCode}
                helperText={errors.postalCode}
            />

            {/* <TextField
                label="Phone Number "
                value={phone}
                onChange={(e) => {
                    setPhone(e.target.value);
                    setErrors({...errors, phone: validatePhone(e.target.value)});
                }}
                fullWidth
                style={{ marginBottom: 16 }}
                error={!!errors.phone}
                helperText={errors.phone}
            /> */}

            {/* <Typography variant="headline" style={{ marginTop: 28 }}>
                Please upload your ID
            </Typography>

            <div style={{ marginTop: 16 }}>
                <input
                    accept="image/*"
                    style={{ display: 'none' }}
                    id="id-front-upload"
                    type="file"
                    onChange={(e) => handleImageUpload(e.target.files[0], 'front')}
                />
                <label htmlFor="id-front-upload">
                    <Button variant="contained" component="span" style={{ width: '100%' }}>
                        ID Front
                    </Button>
                </label>
                {errors.photoIdFront && (
                    <FormHelperText error style={{ marginTop: 4 }}>
                        {errors.photoIdFront}
                    </FormHelperText>
                )}
                {idFront && (
                    <div>
                        <Typography variant="body2" style={{ margin: '8px 0' }}>
                            Front image uploaded
                        </Typography>
                        <ImagePreview imageData={idFront} />
                    </div>
                )}
            </div>

            <div style={{ marginTop: 16 }}>
                <input
                    accept="image/*"
                    style={{ display: 'none' }}
                    id="id-back-upload"
                    type="file"
                    onChange={(e) => handleImageUpload(e.target.files[0], 'back')}
                />
                <label htmlFor="id-back-upload">
                    <Button variant="contained" component="span" style={{ width: '100%' }} >
                        ID Back
                    </Button>
                </label>
                {errors.photoIdBack && (
                    <FormHelperText error style={{ marginTop: 4 }}>
                        {errors.photoIdBack}
                    </FormHelperText>
                )}
                {idBack && (
                    <div>
                        <Typography variant="body2" style={{ margin: '8px 0' }}>
                            Back image uploaded
                        </Typography>
                        <ImagePreview imageData={idBack} />
                    </div>
                )}
            </div> */}
            <Button
                variant="contained"
                color="primary"
                onClick={handleSubmit}
                fullWidth
                style={{ marginTop: 28}}
            >
                Save
            </Button>
        </div>
    );
}

export default UserUpdateForm;

